'use strict';

var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;

var definition = {
  name: 'Group',
  basePath: ':basePath',
  // PURPOSELY NO ENDPOINT. This is because this resource should be fetched only
  // once in the initial data load, and should never be created, updated or
  // deleted during the lifetime of the app. If the user changes, the sysyem
  // must be invalidated (e.g. logout -> login again).
  // endpoint: '/groups',
  debug: false,
  methods: null,
  relations : {}
};

var GroupResource = function(DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

var getResourceOptions = function(options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    name : 'Group',
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {
    },

    modelMethods: {
    },

    // definition formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri
      }
    },

    syncTriggers: {}
  };
};

module.exports = GroupResource;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/group/GroupResource.js